module.exports = __webpack_public_path__ + "img/deterministic_signals_slots.dea438c2.jpg";